import { proformApiQuery } from '@eliadmin/core/src/api/proform/proform-api';
import { useQuery } from '@tanstack/react-query';

export function useProductColorVariants(cislo_nomenklatury: string) {
  return useQuery({
    queryKey: ['GET_PRODUCT_CONF_KOD_FOLIE', { cislo_nomenklatury }],
    queryFn: async () => {
      return proformApiQuery('GET_PRODUCT_CONF_KOD_FOLIE', {
        cislo_nomenklatury: cislo_nomenklatury,
        id_shop: 3,
      }).then(res => {
        if (Array.isArray(res.root.smako_conf_kod_folie?.kod_folie)) {
          return res.root.smako_conf_kod_folie?.kod_folie;
        }

        return [res.root.smako_conf_kod_folie?.kod_folie];
      });
    },
    enabled: Boolean(cislo_nomenklatury),
    retry: false,
    throwOnError: false,
  });
}
